import { useQuery } from "react-query";
import { fetchDpcMessages } from "../services/dpc/dpc.api";

export function useDpcMessages(partnerId?: string, dpcId?: string) {
    const { data: messages, ...rest } = useQuery(
        ["dpcMessages", partnerId, dpcId],
        () => fetchDpcMessages(partnerId!, dpcId!),
        {
            enabled: !!partnerId && !!dpcId,
        }
    );

    return {
        messages,
        ...rest,
    };
}
